import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Switch, withRouter } from 'react-router-dom';
import { ProtectedRoute } from '../helpers/ProtectedRoute';
import Surveys from '../components/surveys/Surveys';
import CreateSurveys from '../components/surveys/CreateSurveys';
import Voting from '../components/surveys/Voting';
import EditSurveys from '../components/surveys/EditSurveys';
import ShowSurveys from '../components/surveys/ShowSurveys';

const SurveysRoutes = ({ match: { url } }) =>
    <Switch>
        <ProtectedRoute exact path={`${url}`} rols={['manager', 'property']} component={Surveys} />
        <ProtectedRoute exact path={`${url}/create/:survey`} rols={['manager']} component={CreateSurveys} />
        <ProtectedRoute exact path={`${url}/edit/:id`} rols={['manager']} component={EditSurveys} />
        <ProtectedRoute exact path={`${url}/preview/:id`} rols={['manager', 'property']} component={ShowSurveys} />
        <ProtectedRoute exact path={`${url}/:voting`} rols={['property']} component={Voting} />
        <Redirect to="/errors/404" />
    </Switch>

SurveysRoutes.propTypes = { match: PropTypes.object.isRequired };

export default withRouter(SurveysRoutes);
